// extracted by mini-css-extract-plugin
module.exports = {"container":"IconGridSection_container__bcxmL","title":"IconGridSection_title__eJyWi","item":"IconGridSection_item__cznNL","iconWrapper":"IconGridSection_iconWrapper__TubxO"};